import type { SVGProps } from "react";

export function CompletedCheckIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="64"
      height="64"
      viewBox="4.26447 0 64.5069 64.5069"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4.26447 16.1267C4.26447 7.22018 11.4846 0 20.3912 0H52.6446C61.5512 0 68.7713 7.22018 68.7713 16.1267V48.3802C68.7713 57.2867 61.5512 64.5069 52.6446 64.5069H20.3912C11.4846 64.5069 4.26447 57.2867 4.26447 48.3802V16.1267Z"
        fill="#0D0D0C"
      />
      <path
        d="M4.26447 16.1267C4.26447 7.22018 11.4846 0 20.3912 0H52.6446C61.5512 0 68.7713 7.22018 68.7713 16.1267V48.3802C68.7713 57.2867 61.5512 64.5069 52.6446 64.5069H20.3912C11.4846 64.5069 4.26447 57.2867 4.26447 48.3802V16.1267Z"
        fill="url(#paint0_radial_545_2012)"
        fillOpacity="0.2"
      />
      <path
        d="M20.3912 0.50396H52.6446C61.2728 0.50396 68.2674 7.49851 68.2674 16.1267V48.3802C68.2674 57.0084 61.2728 64.0029 52.6446 64.0029H20.3912C11.763 64.0029 4.76843 57.0084 4.76843 48.3802V16.1267C4.76843 7.49851 11.763 0.50396 20.3912 0.50396Z"
        stroke="url(#paint1_linear_545_2012)"
        strokeOpacity="0.16"
      />
      <g filter="url(#filter0_d_545_2012)">
        <path
          d="M16.4221 34.2327C16.0285 33.8391 16.0285 33.2009 16.4221 32.8073L22.8513 26.378C23.2449 25.9844 23.8831 25.9844 24.2767 26.378L31.4187 33.52L23.564 41.3746L16.4221 34.2327Z"
          fill="#889875"
        />
        <path
          d="M23.5641 41.3728L48.6176 16.3193C49.0112 15.9257 49.6494 15.9257 50.043 16.3193L56.4723 22.7485C56.8659 23.1421 56.8659 23.7803 56.4723 24.1739L32.1314 48.5148C31.7378 48.9084 31.0996 48.9084 30.706 48.5148L23.5641 41.3728Z"
          fill="#98AA84"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_545_2012"
          x="0"
          y="7.96075"
          width="72.8941"
          height="65.0393"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="8" />
          <feGaussianBlur stdDeviation="8" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0509804 0 0 0 0 0.0705882 0 0 0 0 0.027451 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_545_2012"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_545_2012"
            result="shape"
          />
        </filter>
        <radialGradient
          id="paint0_radial_545_2012"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(4.26447) rotate(45) scale(91.2265)"
        >
          <stop stopColor="#9CC66C" />
          <stop offset="1" stopColor="#0D1307" />
        </radialGradient>
        <linearGradient
          id="paint1_linear_545_2012"
          x1="35.9977"
          y1="31.7332"
          x2="9.46663"
          y2="5.20217"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0D1207" />
          <stop offset="1" stopColor="#F3F8ED" />
        </linearGradient>
      </defs>
    </svg>
  );
}
